"use client";
import React from "react";
import { BiChevronDown } from "react-icons/bi"; // Using one icon only

const MenuItem = ({
    id,
    title,
    hideShow,
    HideShow,
    ArrowShow,
    navTextColor,
    pageUrl,
    onMouseEnter,
    onMouseLeave,
    hoveredItem,
}) => {
    const isHovered = hoveredItem === id;

    return (
        <>
            <span
                className={`menuTitle ${navTextColor} flex MenuList items-center gap-1 cursor-pointer !font-manrope`}
                onMouseEnter={(e) => {
                    onMouseEnter(e, id);
                }}
                onMouseLeave={onMouseLeave}
            >
                {title}
                <div
                    className={`transform transition-transform duration-500 ease-in-out`}
                    style={{
                        transform: isHovered
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                    }}
                >
                    <BiChevronDown />
                </div>
            </span>
            {pageUrl && pageUrl}
        </>
    );
};

export default MenuItem;
